import React from 'react';
import videojs from 'video.js'
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  root: {
    width: '100%',
      padding: 0,
  }
})

class VideoPlayer extends React.Component {
  componentDidMount() {
    // instantiate Video.js
    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      console.log('onPlayerReady', this)
    });
  }

  // destroy player on unmount
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose()
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    const { classes, video } = this.props;

    return (
        <div data-vjs-player className={classes.root}>
          <video ref={ node => this.videoNode = node } className="video-js"></video>
        </div>
    )
  }
}

export default withStyles(styles)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/components/video_player.jsx